import { preload } from 'swr';
import useSWRImmutable from 'swr/immutable';
import noErrorFetcher from './shared/noErrorFetcher';

const config = { url: '/auth/users/me' };

const useMe = () => useSWRImmutable(config, noErrorFetcher, { suspense: true });

preload(config, noErrorFetcher);

export default useMe;
